﻿/* 
Object:         Import
Description:    Logic and events for the module Import
Used in:        Import
*/

/*---[ ESLint ]---*/
/*
    global importconfiguration
*/

window.importconfiguration = function () {

    return {
        
        /**
         * Init (binding button actions) Overview grid
         */
        initialize: function () {
            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("Import/Add");
            });
        },

        /**
         * Delete item from grid
         * @param {any} e
         */
        deleteItem: function (e) {
            var event = e;
            var data = this;

            function callbackYes(event, data) {
                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

                // Post Data
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("Import/Delete?importId=" + dataItem.ImportID),
                    success: function (responseData) {

                        // Refresh datasource grid 
                        $("#ImportGrid").data("kendoGrid").dataSource.read();

                    }
                });
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });
        },

        /**
         * Update a item from grid
         * @param {any} e
         */
        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Label;

            // Edit mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Import/Edit?importId=" + dataItem.ImportID + "&breadcrumbLabel=" + label);
        },

        /**
         * Show item from grid
         * @param {any} e
         */
        showItem: function (e) {
            
            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Label;

            // Show mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Import/Show?importId=" + dataItem.ImportID + "&breadcrumbLabel=" + label);
        },

        visibilityItem: function (dataItem, nodeId) {
            return dataItem.NodeID === nodeId;            
        },

        /**
         * Show item from grid
         * @param {any} e
         */
        importFile: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Label;

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Import/ImportFile?importId=" + dataItem.ImportID + "&breadcrumbLabel=" + label);
        },

        uTCChanged: function (checked) {
            main.setHideDivBootstrap("divSummertime", !checked);
            main.setHideDivBootstrap("divDSTID", !checked);
        },

        onStoreTableNameChanged: function (e) {
            var storeTableName = e.sender.element[0].value;
            $("#DivImportColumns").load(appsettings.getUrl("Import/GetNewImportColumns?storeTableName=" + storeTableName));
        },

        divImportColumns_Refresh: function (importId) {
            $("#DivImportColumns").load(appsettings.getUrl("Import/GetImportColumns?importId=" + importId));
        },

        importColumn_Add_Clicked: function (importId) {
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Import/AddImportColumnItem") + "?importId=" + importId,
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == true) {
                            importconfiguration.divImportColumns_Refresh(importId);

                            //main.openActionsDialog(' ', responseData.Message,
                            //    [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }
                }
            });
        },

        importColumn_Delete_Clicked: function (importColumnId) {
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Import/DeleteImportColumnItem") + "?importColumnId=" + importColumnId,
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == true) {
                            $("#IC_" + importColumnId + "_Row").remove();

                            //if (importColumnId > 0) {
                            //    main.openActionsDialog(' ', responseData.Message,
                            //        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                            //}
                        }
                    }
                }
            });
        }
    }
}();